'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Home, MessageCircleHeart, User, CheckSquare, History, BellRing } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const navItems = [
  { label: 'Home', icon: Home, href: '/home-screen', key: 'nav-home' },
  { label: 'Talk', icon: MessageCircleHeart, href: '/chat-screen', key: 'nav-chat', primary: true },
  { label: 'History', icon: History, href: '/conversations', key: 'nav-history' },
  { label: 'My Day', icon: CheckSquare, href: '/accountability', key: 'nav-accountability' },
  { label: 'Check-Ins', icon: BellRing, href: '/check-ins', key: 'nav-checkins' },
  { label: 'Me', icon: User, href: '/me-screen', key: 'nav-me' },
];

export default function BottomNav() {
  const pathname = usePathname();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex items-center justify-around px-1 py-2 h-16">
        {navItems?.map(({ label, icon: Icon, href, key, primary }) => {
          const isActive = pathname === href || pathname?.startsWith(href);
          return (
            <Link
              key={key}
              href={href}
              className={`flex flex-col items-center gap-1 px-3 py-1.5 rounded-2xl transition-all duration-200 active:scale-90 ${
                isActive
                  ? primary
                    ? 'text-primary' :'text-primary' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              <div
                className={`w-9 h-9 flex items-center justify-center rounded-2xl transition-all duration-200 ${
                  isActive
                    ? primary
                      ? 'lavender-gradient text-white shadow-card-sm'
                      : 'bg-primary/10' :''
                }`}
              >
                <Icon size={18} />
              </div>
              <span className={`text-[9px] font-semibold tracking-wide ${isActive ? 'text-primary' : ''}`}>
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}